import 'animate.css';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { IconButton, Tooltip } from '@mui/material';

/**
 * The properties for the video skipped warning icon
 */
interface VideoSkippedWarningIconProps {
  /**
   * True, if video skipped was detected. False, otherwise
   */
  videoSkipped: boolean;
  /**
   * True, if the module is already complete. False, otherwise
   */
  moduleComplete: boolean;
  /**
   * A method to show the video skipped dialog
   */
  setShowDialogVideoSkipped: () => void;
}

/**
 * An icon to indicate to the user that the video has been skipped
 */
const VideoSkippedWarningIcon = (props: VideoSkippedWarningIconProps) => {
  return props.videoSkipped && !props.moduleComplete ? (
    <Tooltip title="Skip Detected" arrow>
      <IconButton
        className="animate__animated animate__bounce"
        aria-label="Skip Detected"
        onClick={() => props.setShowDialogVideoSkipped()}
        color="warning"
        sx={{
          marginRight: '.1em',
        }}
        size="large"
      >
        <WarningRoundedIcon />
      </IconButton>
    </Tooltip>
  ) : (
    <></>
  );
};

export default VideoSkippedWarningIcon;
